import { useTheme } from '@material-ui/core';
// import { PageDetails } from 'app/core/api/company/api-company.types';
import { useRepairStats } from 'app/core/api/stats/api-stats';
import { useViewport } from 'app/shared/context-hooks/use-viewport.hook';
// import { TileContainer } from 'app/shared/frames/Tile';
import TileCardButton from 'app/shared/frames/TileCardButton';
import { useState, useEffect } from 'react';
// import LoadingOverlay from 'app/shared/page-parts/LoadingOverlay';
import styledConsts from 'app/styles/styledConsts';
import styledFuncs from 'app/styles/styledFuncs';
import styledMixins from 'app/styles/styledMixins';
import { useAssignedProductsRepair } from 'app/core/api/product-assignment/api-product-assignment';
import _ from 'lodash';
import { RepairAssignedProduct } from 'app/core/api/product-assignment/api-product-assignment.types';
import { DateTime } from 'luxon';
import { Bar } from 'react-chartjs-2';
import styled from 'styled-components/macro';

type MetricOpts = {
  $spx: (x: number) => string;
};
type MetricNumberOpts = MetricOpts & {
  $noMetric: boolean;
};
const MetricNumber = styled.div<MetricNumberOpts>`
  color: ${styledConsts.cPrimary};
  ${styledMixins.absoluteCentered}
  ${styledMixins.flexCenter}
  line-height: 1.2;
  font-weight: 600;
  text-align: center;

  font-size: ${p => p.$spx(p.$noMetric ? 14 : 55)};
  opacity: ${p => (p.$noMetric ? 0.6 : 1)};
  width: ${p => (p.$noMetric ? '70%' : 'auto')};
`;

const StyledTileCardButton = styled(TileCardButton)`
  .MuiButton-label > div {
    padding: ${styledFuncs.pad()};
    flex-direction: column;
  }
`;
const NakedTileCardButton = styled(StyledTileCardButton)`
  margin: ${styledFuncs.pad()};
  height: auto;
`;

const noDataMsg = 'No data available yet';

export default function RequestsOverTime(): JSX.Element {
  const theme = useTheme();
  const { resource: stats } = useRepairStats();
  const { resource: assignedProducts } = useAssignedProductsRepair();
  const { casesOverTime } = stats || {};
  const [inProgressProducts, setInProgressProducts] =
    useState<RepairAssignedProduct[]>();
  useEffect(() => {
    const ip = assignedProducts?.filter(
      m => m.currentStatus !== 'new'
    );
    setInProgressProducts(ip);
  }, [assignedProducts]);
  const seriesData = casesOverTime?.series.map(({ count, date }) => ({
    date: DateTime.fromFormat(date, 'yyyy-MM-dd').toFormat('dd MMM'),
    count, // : _.random(10),
  }));
  const noSeriesDataEntries = _.map(seriesData, 'count').every(
    count => count === 0
  );
  const defaultWidth = 375; // px
  const { vWidth } = useViewport();
  const widthSizer = Math.min(vWidth, 420);
  const spx = (x: number) =>
    `${(x * widthSizer ** 0.8) / defaultWidth ** 0.8}px`;
  return (
    <div
      style={{
        width: '100%',
        display:
          (seriesData && seriesData.length > 0) ||
          (inProgressProducts && inProgressProducts.length > 0)
            ? 'block'
            : 'none',
      }}
    >
      <div style={{ display: 'flex' }}>
        {seriesData && (
          <div style={{ width: '96%' }}>
            <h3 style={{ color: '#31AD31', fontWeight: 500 }}>
              Requests over time
            </h3>
            <div>
              <NakedTileCardButton noClickAction>
                {noSeriesDataEntries && (
                  <MetricNumber $spx={spx} $noMetric>
                    {noDataMsg}
                  </MetricNumber>
                )}
                <Bar
                  data={{
                    datasets: [
                      {
                        type: 'bar',
                        data: seriesData,
                        backgroundColor: styledConsts.cPrimary({
                          theme,
                        }),
                      },
                    ],
                  }}
                  options={{
                    parsing: {
                      xAxisKey: 'date',
                      yAxisKey: 'count',
                    },
                    plugins: {
                      legend: { display: false },
                    },
                    scales: {
                      y: { ticks: { precision: 0 } },
                    },
                  }}
                />
              </NakedTileCardButton>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
